export type CarScore = 'basic' | 'economy' | 'premium';

export const carScoreFilterCheckAgainst = ['basic', 'economy', 'premium'];
